export const TITLE_AMENDS_KEY = "title"
export const CODE_AMENDS_KEY = "code"
export const UNIT_OF_MEASURE_AMENDS_KEY = "unitOfMeasure"
export const INTRO_CONTENT_AMENDS_KEY = "intro.content"
export const INTRO_NOTE_AMENDS_KEY = "intro.note"
export const MOVEMENTS_AMENDS_KEY = "movements"
export const TASK_AMENDS_KEY_PREFIX = "tasks."
export { LEGISLATION_AMENDS_KEY_PREFIX } from "./legislation-amends-keys.mjs"
export {
    LEADING_SUMMARY_AMENDS_KEY,
    getLeadingSummaryTaskId,
    isLeadingSummaryTaskId,
} from "./leading-summary-amends-keys.mjs"
